import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import find from 'lodash/find'
import isEqual from 'lodash/isEqual'
import isArray from 'lodash/isArray'
import findIndex from 'lodash/findIndex'
import map from 'lodash/map'
import remove from 'lodash/remove'
import onClickOutside from 'react-onclickoutside'
import Arrow from './assets/ic-arrow-more.svg'
/**
 * Select component
 */
class DualSelect extends Component {
  constructor () {
    super()
    this.state = {
      listOpened: false,
      secondaryOpened: false,
      selected: null,
      currentItem: null
    }

    this.toggleList = this.toggleList.bind(this)
    this.setSelectedFromProp = this.setSelectedFromProp.bind(this)
  }

  handleClickOutside (evt) {
    if (this.state.listOpened) {
      this.setState({ listOpened: !this.state.listOpened, secondaryOpened: !this.state.secondaryOpened })
    }
  }

  setSelectedFromProp (prop, first, items) {
    if (prop) {
      let selected
      if (isArray(prop)) {
        selected = map(prop, (propValue) => find(this.props.items, ({ value }) => value === propValue))
      } else {
        items && items.forEach(item => item.children
            .forEach(child => { if (child.value === prop) selected = child }))
      }

      if (selected) {
        this.setState({ selected }, () => {
          if (isArray(selected)) {
            this.props.onChange && this.props.onChange(this.state.selected)
          } else {
            this.props.onChange && this.props.onChange({ ...this.state.selected, first })
          }
        })
      }
    }
  }

  componentWillMount () {
    this.setSelectedFromProp(this.props.selected, true)
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.selected && nextProps.items.length > 0) {
      let found
      nextProps.items
        .forEach(item => item.children
          .forEach(child => { if (child.value === nextProps.selected) found = child }))
      if (found) {
        if (isEqual(this.state.selected, found)) {
          return false
        }

        this.setSelectedFromProp(nextProps.selected, false, nextProps.items)
      }
    }
  }

  toggleList () {
    this.setState({ listOpened: !this.state.listOpened })
  }

  toggleSecondaryList (item) {
    this.setState({ secondaryOpened: true, currentItem: item })
  }

  selectItem (item) {
    this.setState({ selected: item, listOpened: false, secondaryOpened: false }, () => {
      this.props.onChange && this.props.onChange(this.state.selected)
    })
  }

  selectItems (item) {
    let items = this.state.selected || []

    const found = findIndex(items, (i) => i.value === item.value)

    if (this.props.removedSelectOnSelected && !this.removedFirst) {
      this.props.removedSelectOnSelected.forEach((v) => remove(items, { value: v }))
      this.removedFirst = true
    }

    if (found !== -1) {
      items = items.filter((item, index) => index !== found)
    } else {
      items.push(item)
    }

    this.setState({ selected: items }, () => {
      this.props.onChange && this.props.onChange(this.state.selected)
    })
  }

  renderSecondary () {
    return (
      <SecondaryList>
        {this.state.currentItem && this.state.currentItem.children.map((item) =>
          <Item key={`item-${item.value}${item.label}`} onClick={() => this.selectItem(item)}>
            {item.label}
          </Item>
        )}
      </SecondaryList>)
  }

  render () {
    let {
      placeholder,
      Selector,
      List,
      className,
      items,
      checkboxed
    } = this.props

    let SelectorText = placeholder

    // Set default
    if (!Selector) {
      Selector = DefaultSelector
    }

    if (!List) {
      List = DefaultList
    }

    if (this.state.listOpened) {
      List = DefaultListOpened
    }

    if (this.state.selected) {
      if (this.state.selected.icon) {
        SelectorText = (
          <span>
            <Icon src={this.state.selected.icon} alt={this.state.selected.label} />
            {this.state.selected.label}
          </span>
        )
      } else {
        SelectorText = this.state.selected.label
      }
    }

    const isChecked = ({ value }) => {
      if (this.state.selected) {
        if (isArray(this.state.selected)) {
          return findIndex(this.state.selected, (i) => i.value === value) !== -1
        }
      } else {
        return this.state.selected === value
      }
    }

    return (
      <Wrapper className={className} >
        <Selector
          onClick={!this.props.disabled && this.toggleList}
          className={this.state.selected && 'selected'}
          opened={this.state.listOpened}
          arrowIcon={this.props.arrowIcon}
          icon={this.props.icon}
          disabled={this.props.disabled}>
          {!checkboxed ? SelectorText : placeholder}
        </Selector>
        <List>
          {items && items.map((item) =>
            <Item key={`item-${item.value}${item.label}`} onClick={() => this.toggleSecondaryList(item)}>
              {item.icon && <Icon src={item.icon} />}
              {checkboxed ? <Checkbox checked={isChecked(item)} /> : ''}
              {item.label}
              {this.state.currentItem === item &&
                <OpenIcon />
              }
            </Item>
          )}
        </List>
        {this.state.secondaryOpened && this.renderSecondary()}
      </Wrapper>
    )
  }
}

DualSelect.propTypes = {
  icon: PropTypes.string,
  arrowIcon: PropTypes.string,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.object),
  checkboxed: PropTypes.bool,
  onChange: PropTypes.func,
  removedSelectOnSelected: PropTypes.arrayOf(PropTypes.string),
  List: PropTypes.object,
  Selector: PropTypes.object,
  selected: PropTypes.number
}

export default onClickOutside(DualSelect)

export const Icon = styled.img`
  width: 35px;
  height: 35px;
  display: inline-block;
  vertical-align: middle;
  margin-right: 10px;
`

export const Wrapper = styled.div`
  position: relative;
  max-width: 200px;

`

export const DefaultSelector = styled.div`
  padding: 15px 16px;
  font-size: 14px;
  line-height: 18px;
  font-weight: bold;
  background-color: #FFFFFF;
  color: #9C9C9C;
  display: flex;
  align-items: center;
  background-position: right center;
  background-repeat: no-repeat;
  border: 1px solid #EFEFEF;
  cursor: pointer;
  position: relative;

  &::after {
    content: " ";
    display: block;
    background-image: url(${({ arrowIcon }) => arrowIcon});
    background-size: contain;
    width: 12px;
    height: 12px;
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    background-repeat: no-repeat;
    background-position: center;

    ${(props) => props.opened && `
      transform: translateY(-50%)rotate(180deg);
    `}
  }

  &.selected {
    color: #3E3E3E;
    font-weight: bold;
  }

  &[disabled] {
    background-color: transparent;
    border: 0;
    color: #676767;
    opacity: 0.5;
    pointer-events: none;
  }

  &:focus {
    border-color: #93C13E;
  }

  background-position: 16px center;
  background-repeat: no-repeat;
  background-size: 16.5px;

  ${(props) => props.icon ? `background-image: url(${props.icon});` : ''}
  ${(props) => props.icon ? `padding-left: 40px` : ''}
`

export const DefaultList = styled.div`
  height: 0;
  opacity: 0;
  width: 100%;
  max-height: 200px;
  overflow: auto;
  border: 1px solid #EFEFEF;
  border-top: 0;
  border-radius: 0 2px 2px 0;
  box-shadow: 0 0 0 1px #EFEFEF;
  transition: all .4s ease-in-out;
  background: #FFF;
  position: absolute;
  z-index: 55;
`

export const DefaultListOpened = styled(DefaultList)`
  height: auto;
  opacity: 1;
  transition: all .4s ease-in-out;
`

const SecondaryList = styled(DefaultList)`
  left: 100%;
  height: auto;
  opacity: 1;
`

export const Item = styled.div`
  padding: 10px 15px;
  transition: all .2s ease;
  cursor: pointer;
  user-select: none;
  font-size: 14px;
  position: relative;

  &:hover {
    background-color: #EFEFEF;
  }
`

export const Checkbox = styled.span`
  border: 1px solid #BABABA;
  width: 16px;
  height: 16px;
  display: inline-block;
  vertical-align: middle;
  margin-right: 10px;


  ${(props) => props.checked ? `
    &:after {
      content: "✓";
      color: #93C13E;
      display: block;
      width: 14px;
      font-size: 10px;
      text-align: center;
      line-height: 18px;
    }
  ` : ''}
`

const OpenIcon = styled.div`
    position: relative;
    background: url(${Arrow}) no-repeat;
    background-size: contain;
    width: 10px;
    height: 10px;
    position: absolute;
    right: 15px;
    top: 15px;
`



// WEBPACK FOOTER //
// ./src/components/DualSelect/index.js